// This file is full of browser-provided constants that someone is virtually guaranteed to redefine
// underneath you at some point. If you find yourself using a new one that you could possibly avoid
// reading, stuff it in here and use that instead.
export const Node_ELEMENT_NODE = 1;
export const Node_ATTRIBUTE_NODE = 2;
export const Node_TEXT_NODE = 3;
export const Node_CDATA_SECTION_NODE = 4;
export const Node_ENTITY_REFERENCE_NODE = 5;
export const Node_ENTITY_NODE = 6;
export const Node_PROCESSING_INSTRUCTION_NODE = 7;
export const Node_COMMENT_NODE = 8;
export const Node_DOCUMENT_NODE = 9;
export const Node_DOCUMENT_TYPE_NODE = 10;
export const Node_DOCUMENT_FRAGMENT_NODE = 11;
export const Node_NOTATION_NODE = 12;

export const XHR_UNSENT = 0;
export const XHR_OPENED = 1;
export const XHR_HEADERS_RECEIVED = 2;
export const XHR_LOADING = 3;
export const XHR_DONE = 4;
export const XHR_STATUS_ABORTED = 0;
